import { render } from "./PrimeiroRegistro.vue?vue&type=template&id=8e40f10a"
import script from "./PrimeiroRegistro.vue?vue&type=script&lang=js"
export * from "./PrimeiroRegistro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__